var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Alert, Button, ButtonVariant } from "@merge-api/merge-javascript-shared";
import { AlertTriangle, RefreshCw } from "lucide-react";
export var ErrorMessage = function (_a) {
    var message = _a.message, onRetry = _a.onRetry;
    return (_jsx("div", __assign({ className: "flex w-full justify-start" }, { children: _jsx("div", __assign({ className: "w-[65%]" }, { children: _jsx(Alert, __assign({ color: "red", icon: _jsx(AlertTriangle, { size: 16 }), buttons: onRetry && (_jsx(Button, __assign({ variant: ButtonVariant.TertiaryWhite, onClick: onRetry, leftIcon: _jsx(RefreshCw, { size: 12 }), size: "sm" }, { children: "Retry" }))) }, { children: message })) })) })));
};
